export interface IEmployeeList {
  list: IEmployee[];
  count: number;
  totalPages: number;
}

export interface IEmployeeCreate {
  name: string;
  email: string;
  cpf: string;
  phone: string;
}

export interface IEmployee {
  id: string;
  name: string;
  email: string;
  cpf: string;
  phone: string;
  employmentRelationship: boolean;
  company: {
    completedSignUp: boolean;
  };
}

export const EmployeeDefaultValues: IEmployeeCreate = {
  name: '',
  email: '',
  cpf: '',
  phone: '',
};

export const ThemeStatus = {
  active: { color: '#4CAF50', title: 'Ativo' },
  inactive: { color: '#F24E1E', title: 'Inativo' },
};

export type IEmployeeStatus = keyof typeof ThemeStatus;

